import React from "react"

import {ElementFormatType, LexicalEditor} from "lexical"
import PopupMenuButton from "../../../../../popover-menu/popup-menu-button/popup-menu-button"
import ToolbarAlignButton from "./align-button"
import ToolbarAlignMenu from "./align-menu"
import ToolbarListButton from "../list/list-button";
import ToolbarListMenu from "../list/list-menu";

export enum AlignType {
    LEFT    = 'left',
    CENTER  = 'center',
    RIGHT   = 'right',
    JUSTIFY = 'justify',
    OUTDENT = 'outdent',
    INDENT  = 'indent',
}

type Props = {
    editor          : LexicalEditor
    elementFormat   : ElementFormatType
    isRTL           : boolean
    blockType       : null | string
}

export default function AlignToolbar(props: Props): JSX.Element {

    const options = [
        {value: AlignType.LEFT,     icon: 'editor-i5-left-align',       label: 'Left align'},
        {value: AlignType.CENTER,   icon: 'editor-i5-center-align',     label: 'Center align'},
        {value: AlignType.RIGHT,    icon: 'editor-i5-right-align',      label: 'Right align'},
        {value: AlignType.JUSTIFY,  icon: 'editor-i5-justify-align',    label: 'Justify align'},
        'separator',
        {value: AlignType.OUTDENT,  icon: props.isRTL ? 'editor-i5-indent' : 'editor-i5-outdent',   label: 'Outdent'},
        {value: AlignType.INDENT,   icon: props.isRTL ? 'editor-i5-outdent' : 'editor-i5-indent',   label: 'Indent'},
    ]

    return (
        <PopupMenuButton hint           = "Align options"
                         btnComponent   = {ToolbarAlignButton}
                         menuComponent  = {ToolbarAlignMenu}
                         menuParams     = {{
                             options        : options,
                             editor         : props.editor,
                             elementFormat  : props.elementFormat,
                             isRTL          : props.isRTL
                         }}/>
    )
}